import React from "react";
import { Card } from "flowbite-react";

// function ExtracurricularRecommendations() {
//   return (
//     <Card className="mb-4">
//       <h2 className="text-2xl font-semibold mb-4">
//         Academic Journey Planning
//       </h2>
//       <section className="mb-6">
//         <h3 className="text-xl font-medium mb-2">Full Journey Roadmap</h3>
//         <p className="text-gray-700">
//           Develop a comprehensive planning tool that outlines a student’s
//           educational trajectory from high school or upgrading courses to
//           college program prerequisites and beyond. This roadmap will visually
//           map:
//         </p>
//         <ul className="list-disc list-inside mt-2 text-gray-700">
//           <li>
//             <strong>Foundational Learning:</strong> Identify the high school or
//             preparatory courses needed.
//           </li>
//           <li>
//             <strong>Program Entry Requirements:</strong> Display prerequisites
//             for various college programs.
//           </li>
//           <li>
//             <strong>Academic Progression:</strong> Lay out a step-by-step
//             pathway showing course sequencing once enrolled.
//           </li>
//         </ul>
//       </section>
//       <section>
//         <h3 className="text-xl font-medium mb-2">
//           Transcript &amp; Data Integration
//         </h3>
//         <p className="text-gray-700">
//           Enable students to input or upload their transcripts. The system
//           will analyze their academic standing, identify gaps or required
//           courses, and align this information with career and program
//           recommendations.
//         </p>
//       </section>
//     </Card>
//   );
// }

// export default ExtracurricularRecommendations;

function ExtracurricularRecommendations() {
  return (
    <Card className="mb-4 mt-3">
      <h2 className="text-2xl font-semibold text-center">Coming Soon!</h2>
    </Card>
  );
}

export default ExtracurricularRecommendations;
